var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerfil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C11.2598 0 12.468 0.500445 13.3588 1.39124C14.2496 2.28204 14.75 3.49022 14.75 4.75C14.75 6.00978 14.2496 7.21796 13.3588 8.10876C12.468 8.99956 11.2598 9.5 10 9.5C8.74022 9.5 7.53204 8.99956 6.64124 8.10876C5.75044 7.21796 5.25 6.00978 5.25 4.75C5.25 3.49022 5.75044 2.28204 6.64124 1.39124C7.53204 0.500445 8.74022 0 10 0ZM10 11.875C15.2487 11.875 19.5 14.0006 19.5 16.625V19H0.5V16.625C0.5 14.0006 4.75125 11.875 10 11.875Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerfil);
export default __webpack_public_path__ + "static/media/Perfil.f95ca9b7a03044c97473f0ebea8954e9.svg";
export { ForwardRef as ReactComponent };